import React, { useContext, useEffect, useState } from 'react';
import { SwipeableViewsContext, PayRatesContext } from '../PayRates';
import RedirectToLogin from '../../../utils/RedirectToLogin';
import { getCurrentUser } from '../../../services/authService';
import { getPositionByDepartment } from '../../../services/positionsService';
import PositionsPayRateFilters from './PositionsPayRateUtils/PositionsPayRateFilters';
import PositionsPayRateList from './PositionsPayRateUtils/PositionsPayRateList';
import './PositionsPayRate.scss';

function PositionsPayRate() {
  const payRatesContext = useContext(PayRatesContext);
  const swipeableViewsContext = useContext(SwipeableViewsContext);
  const [departmentIdSelected, setDepartmentIdSelected] = useState(null);
  const [positions, setPositions] = useState([]);

  useEffect(() => {
    swipeableViewsContext.updateSwipeableHeight();
  });

  useEffect(() => {
    const getDepartmentPositions = async () => {
      const { data } = await getPositionByDepartment(departmentIdSelected);
      setPositions(data.positions);
    }
    departmentIdSelected && getDepartmentPositions();
  }, [departmentIdSelected]);

  return (
    !getCurrentUser()
      ? <RedirectToLogin location={payRatesContext.props.location} />
      : <section className="PositionsPayRate content-wrapper container-fluid">
          <PositionsPayRateFilters setDepartmentIdSelected={setDepartmentIdSelected} />
          <PositionsPayRateList positions={positions} />
        </section>
  )
}

export default PositionsPayRate
